import {Component} from '@angular/core';

@Component({
  selector: 'app-enterprise-expired',
  templateUrl: './free-trial-expired.component.html',
  styleUrls: ['./free-trial-expired.component.scss']
})
export class EnterpriseFreeTrialExpiredComponent {

}
